import ACTIONS from "../actions/ServiceDetailActions"
import _ from "lodash";

const initialState = {
    loading: true,
    hasErrors: false,
    deleteServiceWarning: false,
    service: {},
    dpSources: [],
    dpInputFields: [],
    requiredInputs: [],
    associatedTenants: {},
    associatedCountries: [],
    displayTableTenants: null,
}

/**
 * Reducer to manage state relevant to the
 * individual service selected.
 * */
const serviceDetailReducer = (state = initialState, action) => {
    switch (action.type) {

        case ACTIONS.Details.LOAD_SERVICE_DETAIL: {
            let newState = _.cloneDeep(state);
            newState.service = action.payload.serviceDetail;
            newState.dpSources = action.payload.serviceDetail.associated_sources;
            newState.dpInputFields = action.payload.inputFields;
            newState.associatedTenants = action.payload.serviceDetail.associated_tenants;
            newState.associatedCountries = Object.keys(newState.associatedTenants);

            return newState;
        }

        case ACTIONS.Details.DELETE_SERVICE_WARNING: {
            let newState = _.cloneDeep(state);
            newState.deleteServiceWarning = !newState.deleteServiceWarning;
            return newState;
        }

        case ACTIONS.Details.CLEAR_CURRENT_SERVICE_DETAIL: {
            return initialState;
        }

        default:
            return state
    }
};

export default serviceDetailReducer;
